var generateStyle = function generateStyle(componentTheme) {
  return {
    bankRow: {
      display: 'flex',
      flexDirection: 'row',
      borderBottom: "".concat(componentTheme.bankRowBorderWidth, " solid ").concat(componentTheme.bankRowBorderColor)
    },
    bankInfo: {
      margin: "".concat(componentTheme.bankInfoMargin, " 0"),
      flex: 1
    },
    bankTitle: {
      fontSize: componentTheme.bankTitleFontSize,
      paddingBottom: componentTheme.bankTitlePadding
    },
    bankDetails: {
      color: componentTheme.bankDetailsColor,
      fontSize: componentTheme.bankDetailsFontSize
    },
    bankOptions: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    bankOptionIcon: {
      verticalAlign: 'middle',
      marginRight: componentTheme.BankOptionIconMargin,
      fontSize: componentTheme.BankOptionIconFontSize
    },
    bankTitleLinkColor: componentTheme.bankTitleLinkColor,
    bankTitleLinkHoverColor: componentTheme.bankTitleLinkHoverColor,
    deleteAlert: {
      display: 'block'
    },
    deletePreface: {
      marginBottom: componentTheme.deletePrefaceMargin
    },
    rowHeader: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
};
export default generateStyle;